import { UseMutateAsyncFunction, useMutation } from 'react-query';

import {
  ClientLoginWithCodeRequestType,
  ClientLoginWithCodeResponseType
} from '../../../services/PaymentsAuthServices/APIService/types';

import { usePaymentsAuthAPIService } from '../usePaymentsAuthAPIService';

function useGetPaymentsClientAuthDetails(): {
  getPaymentsClientAuthDetailsAPI: UseMutateAsyncFunction<
    ClientLoginWithCodeResponseType,
    unknown,
    ClientLoginWithCodeRequestType,
    unknown
  >;
  error;
  status;
} {
  const { paymentsAuthAPIService } = usePaymentsAuthAPIService();

  const getAuthDetails = (requestObject: ClientLoginWithCodeRequestType) => {
    return paymentsAuthAPIService.onLogin(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(getAuthDetails);

  return {
    getPaymentsClientAuthDetailsAPI: mutateAsync,
    error,
    status
  };
}

export { useGetPaymentsClientAuthDetails };
